// Getting rid of properties from overfetched data

export const delUnusedData = (data, code, index) => {
  data.results[index].realLocation.countryCode = code;
  data.results[index].realLocation.coords = null;
  delete data.results[index].location.coordinates;
  delete data.results[index].location.timezone;
  delete data.results[index].login.md5;
  delete data.results[index].login.password;
  delete data.results[index].login.salt;
  delete data.results[index].login.sha1;
  delete data.results[index].login.sha256;
};
